<template>
<v-card
class="news-card"
>
    <!-- Card Title -->
    <v-card-title class="text-h5 font-weight-bold red--text">
    Latest News
    </v-card-title>

    <v-divider></v-divider>

    <!-- News Items -->
    <v-card-text>
    <v-list>
        <v-list-item
        v-for="(news, index) in latestNews"
        :key="index"
        :to="news.link"
        class="px-0"
        link
        >
        <v-list-item-content>
            <v-list-item-subtitle class="text-caption text-sm-caption grey--text mb-1">
            {{ news.date }}
            </v-list-item-subtitle>
            <v-list-item-title class="text-body-2">
            {{ news.text }}
            </v-list-item-title>
        </v-list-item-content>
        </v-list-item>
    </v-list>
    </v-card-text>

    <v-divider></v-divider>

    <!-- See All News Link -->
    <v-card-actions>
    <v-btn
        text
        color="primary"
        to="/all-news"
        class="text-none text-body-2 text-sm-body-1"
    >
        See all news
        <v-icon right>mdi-chevron-right</v-icon>
    </v-btn>
    </v-card-actions>
</v-card>
</template>

<script>
export default {
name: 'NewsSection',
props: {
    latestNews: {
        type: Array,
    },
},
};
</script>

<style scoped>
.news-card {
max-width: 700px;
}

.v-list-item__title, .v-list-item__subtitle{
    white-space: unset !important;
}
</style>